{
  "$schema": "https://mux.run/theme.json",
  "name": "Kanagawa",
  "id": "kanagawa",
  "light": {
    "palette": {
      "neutral": "#F2E9DE",
      "ink": "#54433A",
      "primary": "#2D4F67",
      "accent": "#D27E99",
      "success": "#98BB6C",
      "warning": "#D7A657",
      "error": "#E82424",
      "info": "#76946A",
      "diffAdd": "#89AF5B",
      "diffDelete": "#D61F1F"
    },
    "overrides": {
      "text-weak": "#9E9389",
      "syntax-comment": "#9E9389",
      "syntax-keyword": "#957FB8",
      "syntax-string": "#98BB6C",
      "syntax-primitive": "#2D4F67",
      "syntax-variable": "#54433A",
      "syntax-property": "#76946A",
      "syntax-type": "#C38D9D",
      "syntax-constant": "#D7A657",
      "syntax-operator": "#D27E99",
      "syntax-punctuation": "#54433A",
      "syntax-object": "#54433A",
      "markdown-heading": "#957FB8",
      "markdown-text": "#54433A",
      "markdown-link": "#2D4F67",
      "markdown-link-text": "#76946A",
      "markdown-code": "#98BB6C",
      "markdown-block-quote": "#9E9389",
      "markdown-emph": "#C38D9D",
      "markdown-strong": "#D7A657",
      "markdown-horizontal-rule": "#9E9389",
      "markdown-list-item": "#2D4F67",
      "markdown-list-enumeration": "#76946A",
      "markdown-image": "#2D4F67",
      "markdown-image-text": "#76946A",
      "markdown-code-block": "#54433A"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#1F1F28",
      "ink": "#DCD7BA",
      "primary": "#7E9CD8",
      "accent": "#D27E99",
      "success": "#98BB6C",
      "warning": "#D7A657",
      "error": "#E82424",
      "info": "#76946A",
      "diffAdd": "#A9D977",
      "diffDelete": "#F24A4A"
    },
    "overrides": {
      "text-weak": "#727169",
      "syntax-comment": "#727169",
      "syntax-keyword": "#957FB8",
      "syntax-string": "#98BB6C",
      "syntax-primitive": "#7E9CD8",
      "syntax-variable": "#DCD7BA",
      "syntax-property": "#76946A",
      "syntax-type": "#C38D9D",
      "syntax-constant": "#D7A657",
      "syntax-operator": "#D27E99",
      "syntax-punctuation": "#DCD7BA",
      "syntax-object": "#DCD7BA",
      "markdown-heading": "#957FB8",
      "markdown-text": "#DCD7BA",
      "markdown-link": "#7E9CD8",
      "markdown-link-text": "#76946A",
      "markdown-code": "#98BB6C",
      "markdown-block-quote": "#727169",
      "markdown-emph": "#C38D9D",
      "markdown-strong": "#D7A657",
      "markdown-horizontal-rule": "#727169",
      "markdown-list-item": "#7E9CD8",
      "markdown-list-enumeration": "#76946A",
      "markdown-image": "#7E9CD8",
      "markdown-image-text": "#76946A",
      "markdown-code-block": "#DCD7BA"
    }
  }
}
